
import './App.css';
import { Box } from '@chakra-ui/react';
import Navbar from './layout/Navbar';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { MainScreen } from './pages';

function App() {
  return (
    <Box>
      <Navbar />
      <Box bg='#F7EEE5'>
        <Router>
          <Routes>
            <Route path='/' element={<MainScreen />} />
           
          </Routes>
        </Router>
      </Box>
    </Box>
  );
}

export default App;
